module.exports = __webpack_public_path__ + "static/media/product_var_low.cdf7e64a.png";